import { useQuery } from '@apollo/client';
import { getMultiBuildingServiceRequestFilterAttributesQuery } from 'graphql-queries';

export interface SelectOption {
  name: string;
  id: string;
}

export type MultiBuildingServiceRequestFilterOptions = {
  companies: SelectOption[];
  categories: string[];
  statuses: string[];
  issues: string[];
  locations: string[];
  equipment: SelectOption[];
  historyStatuses: string[];
};

interface MultiBuildingServiceRequestFilterAttributesData {
  multiBuildingServiceRequestFilterAttributes: MultiBuildingServiceRequestFilterOptions;
}

export interface UseMultiBuildingServiceRequestFilterAttributesParams {
  channelIds?: string[];
}

export interface UseMultiBuildingServiceRequestFilterAttributesResult {
  filterOptions: MultiBuildingServiceRequestFilterOptions;
  loading: boolean;
  error: ReturnType<typeof useQuery>['error'];
}

const emptyFilterOptions: MultiBuildingServiceRequestFilterOptions = {
  companies: [],
  categories: [],
  statuses: [],
  issues: [],
  locations: [],
  equipment: [],
  historyStatuses: [],
};

export function useMultiBuildingServiceRequestFilterAttributes(
  params: UseMultiBuildingServiceRequestFilterAttributesParams
): UseMultiBuildingServiceRequestFilterAttributesResult {
  const { data, loading, error } =
    useQuery<MultiBuildingServiceRequestFilterAttributesData>(
      getMultiBuildingServiceRequestFilterAttributesQuery,
      {
        variables: {
          channelIds: params.channelIds,
        },
        fetchPolicy: 'network-only',
      }
    );

  return {
    filterOptions:
      data?.multiBuildingServiceRequestFilterAttributes ?? emptyFilterOptions,
    loading,
    error,
  };
}
